import { createFileRoute } from '@tanstack/react-router'
import node, {
  type branchExplorerPageQuery,
} from '#gen/relay/branchExplorerPageQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/branch/explorer',
)({
  staticData: { title: 'Explorer  - [graph]' },
  async loader({ context, params }) {
    return context.preload<branchExplorerPageQuery>(node, params)
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/settings/branch-explorer-page'),
    'BranchExplorerPage',
  ),
})
